(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-contact"]) return;
  try {
    
  const coatingsParams = new URLSearchParams(window.location.search);
  const coatingsField = document.getElementById('cc-contact-product');
  if (coatingsField) coatingsField.value = [coatingsParams.get('product') || coatingsParams.get('category'), coatingsParams.get('sku')].filter(Boolean).join(' — ');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-diy"] && !Shopify.designMode) return;
  try {
    
  function initializeDiyCenters(root = document) {
    root.querySelectorAll('[data-diy-center]').forEach((center) => {
      if (center.dataset.diyReady) return;
      center.dataset.diyReady = 'true';
      const form = center.querySelector('[data-diy-form]');
      const select = center.querySelector('[data-diy-select]');
      const area = center.querySelector('[data-diy-area]');
      const result = center.querySelector('[data-diy-result]');
      const summary = center.querySelector('[data-diy-summary]');
      const enquiry = center.querySelector('[data-diy-enquiry]');
      const contactUrl = new URL(enquiry.href, window.location.origin);
      center.querySelectorAll('[data-diy-project]').forEach((link) => {
        link.addEventListener('click', () => {
          select.value = link.dataset.diyProject;
          result.hidden = true;
          requestAnimationFrame(() => select.focus({ preventScroll: true }));
        });
      });
      form.addEventListener('input', () => { result.hidden = true; });
      form.addEventListener('change', () => { result.hidden = true; });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!form.reportValidity() || !Number.isFinite(area.valueAsNumber) || area.valueAsNumber <= 0) return;
        const label = select.options[select.selectedIndex].text;
        const measurement = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 2 }).format(area.valueAsNumber);
        summary.textContent = label + ' · ' + measurement + ' ' + summary.dataset.unit;
        center.querySelectorAll('[data-diy-checklist]').forEach((list) => { list.hidden = list.dataset.diyChecklist !== select.value; });
        const url = new URL(contactUrl);
        url.searchParams.set('category', 'DIY — ' + label + ' — ' + measurement + ' ' + summary.dataset.unit);
        enquiry.href = url.toString();
        result.hidden = false;
        center.querySelector('[data-diy-result-title]').focus({ preventScroll: true });
        result.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      });
    });
  }
  initializeDiyCenters();
  document.addEventListener('shopify:section:load', (event) => initializeDiyCenters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-header"]) return;
  try {
    
  function initializeCoatingsHoverMenus(scope) {
    scope.querySelectorAll('.cc-nav-dropdown').forEach(menu => {
      if (menu.dataset.ccHoverReady) return;
      menu.dataset.ccHoverReady = 'true';
      let closeTimer;
      menu.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width:750px) and (hover:hover) and (pointer:fine)').matches) return;
        clearTimeout(closeTimer);
        menu.closest('.cc-desktop-nav').querySelectorAll('.cc-nav-dropdown[open]').forEach(other => { if (other !== menu) other.open = false; });
        menu.open = true;
      });
      menu.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        closeTimer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 180);
      });
      menu.addEventListener('focusout', event => {
        if (!menu.contains(event.relatedTarget) && !menu.matches(':hover')) menu.open = false;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeCoatingsHoverMenus(document));
  else initializeCoatingsHoverMenus(document);
  document.addEventListener('shopify:section:load', event => initializeCoatingsHoverMenus(event.target));
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.cc-nav-dropdown[open]').forEach((menu) => { if (!menu.contains(event.target)) menu.removeAttribute('open'); });
    document.querySelectorAll('.cc-mobile-menu[open]').forEach((menu) => { if (!menu.contains(event.target)) menu.removeAttribute('open'); });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.cc-header details[open]').forEach((menu) => { menu.removeAttribute('open'); menu.querySelector('summary')?.focus(); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-page"]) return;
  try {
    
  function initCoatingsLibrary() {
    const input = document.querySelector('[data-cc-library-search]');
    if (!input || input.dataset.bound) return;
    input.dataset.bound = 'true';
    input.addEventListener('input', () => {
      const term = input.value.trim().toLowerCase();
      let found = 0;
      document.querySelectorAll('[data-cc-document-row]').forEach(row => { row.hidden = !row.textContent.toLowerCase().includes(term); if (!row.hidden) found++; });
      const empty = document.querySelector('[data-cc-library-empty]');
      if (empty) empty.hidden = found > 0;
    });
  }
  initCoatingsLibrary();
  document.addEventListener('shopify:section:load', initCoatingsLibrary);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-product"]) return;
  try {
    
  function syncCoatingsVariant(select, updateUrl = true) {
    const root = select.closest('[data-cc-product]');
    const option = select.selectedOptions[0];
    if (!root || !option) return;
    const canBuy = option.dataset.canBuy === 'true';
    const available = option.dataset.available === 'true' && option.dataset.inStock === 'true';
    const price = root.querySelector('.cc-product-price');
    price.textContent = option.dataset.price;
    price.hidden = !canBuy;
    root.querySelector('.cc-price-notice').hidden = canBuy;
    root.querySelector('[data-cc-sku]').textContent = option.dataset.sku;
    root.querySelector('.cc-product-sku').hidden = !option.dataset.sku;
    const needsColor = option.dataset.requiresColor === 'true';
    root.querySelector('[data-cc-purchase]').hidden = !canBuy || needsColor;
    const confirm = root.querySelector('[data-cc-confirm-color]');
    if (confirm) { confirm.hidden = !needsColor; confirm.querySelector('a').href = option.dataset.enquiryUrl + '&request=color'; }
    const form = root.querySelector('.cc-purchase-form');
    form.querySelector('[name="id"]').value = option.value;
    const button = form.querySelector('button[type="submit"]');
    button.disabled = !canBuy || !available || needsColor;
    button.querySelector('[data-cc-submit-label]').textContent = root.querySelector(available ? '[data-cc-cart-label]' : '[data-cc-unavailable-label]').textContent;
    const shipping = button.querySelector('[data-cc-cart-shipping]');
    shipping.hidden = !available || option.dataset.requiresShipping !== 'true';
    shipping.textContent = option.dataset.dispatchEligible === 'true' ? shipping.dataset.fast : shipping.dataset.check;
    const enquiry = root.querySelector('[data-cc-enquiry]');
    enquiry.hidden = canBuy;
    enquiry.href = option.dataset.enquiryUrl;
    const image = root.querySelector('.cc-product-main-image');
    if (image && option.dataset.image && image.getAttribute('src') !== option.dataset.image) {
      image.removeAttribute('srcset');
      image.src = option.dataset.image;
      image.alt = option.dataset.imageAlt;
    }
    root.querySelector('cc-shipping-benefits')?.updateFromSelection?.(option);
    syncColorFloorControls(root, option);
    syncCatalogControls(root, option);
    syncIntegralColorControls(root, option);
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState(window.history.state, '', url);
    }
  }
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-cc-variant]')) syncCoatingsVariant(event.target);
  });
  window.addEventListener('popstate', () => {
    const id = new URL(window.location.href).searchParams.get('variant');
    document.querySelectorAll('[data-cc-variant]').forEach((select) => {
      const option = Array.from(select.options).find((item) => item.value === id) || Array.from(select.options).find((item) => item.defaultSelected);
      if (option) { select.value = option.value; syncCoatingsVariant(select, false); }
    });
  });

  function syncColorFloorControls(root, option) {
    const picker = root.querySelector('[data-cc-color-floor]');
    if (!picker) return;
    root.querySelector('[data-cc-size]').value = option.dataset.size;
    root.querySelectorAll('[data-cc-color-name]').forEach((label) => { label.textContent = option.dataset.color; });
    const variants = Array.from(root.querySelector('[data-cc-variant]').options);
    picker.querySelectorAll('[data-cc-color]').forEach((chip) => {
      const match = variants.find((item) => item.dataset.size === option.dataset.size && item.dataset.color === chip.dataset.ccColor);
      chip.disabled = !match || match.dataset.inStock !== 'true';
      chip.setAttribute('aria-pressed', String(chip.dataset.ccColor === option.dataset.color));
      chip.title = chip.dataset.ccColor + (chip.disabled ? ' — ' + root.querySelector('[data-cc-unavailable-label]').textContent : '');
    });
  }
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-cc-size]')) return;
    const root = event.target.closest('[data-cc-product]');
    const select = root.querySelector('[data-cc-variant]');
    const color = select.selectedOptions[0].dataset.color;
    const variants = Array.from(select.options);
    const match = variants.find((item) => item.dataset.size === event.target.value && item.dataset.color === color);
    const fallback = variants.find((item) => item.dataset.size === event.target.value && item.dataset.inStock === 'true') || variants.find((item) => item.dataset.size === event.target.value);
    const next = match || fallback;
    if (next) { select.value = next.value; syncCoatingsVariant(select); }
  });
  document.addEventListener('click', (event) => {
    const chip = event.target.closest('[data-cc-color]');
    if (!chip || chip.disabled) return;
    const root = chip.closest('[data-cc-product]');
    const select = root.querySelector('[data-cc-variant]');
    const size = root.querySelector('[data-cc-size]').value;
    const next = Array.from(select.options).find((item) => item.dataset.color === chip.dataset.ccColor && item.dataset.size === size && item.dataset.inStock === 'true');
    if (next) { select.value = next.value; syncCoatingsVariant(select); }
  });
  const colorFloorViewport = window.matchMedia('(max-width:749px)');
  function syncColorFloorImage(root) {
    const image = root.querySelector('.cc-product-main-image');
    const destination = root.querySelector(colorFloorViewport.matches ? '[data-cc-color-floor-mobile-image]' : '[data-cc-color-floor-desktop-image]');
    if (image && destination && image.parentElement !== destination) destination.appendChild(image);
  }
  colorFloorViewport.addEventListener('change', () => {
    document.querySelectorAll('.cc-color-floor-layout').forEach(syncColorFloorImage);
  });
  function initializeColorFloor(scope) {
    scope.querySelectorAll('[data-cc-color-floor]').forEach((picker) => {
      const root = picker.closest('[data-cc-product]');
      syncColorFloorImage(root);
      syncCoatingsVariant(root.querySelector('[data-cc-variant]'), false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeColorFloor(document));
  else initializeColorFloor(document);
  document.addEventListener('shopify:section:load', (event) => initializeColorFloor(event.target));
  function syncCatalogControls(root, option) {
    const variants = Array.from(root.querySelector('[data-cc-variant]').options);
    root.querySelectorAll('[data-cc-option-select]').forEach(control => {
      const position = control.dataset.ccOptionSelect;
      control.value = option.dataset['option' + position];
      Array.from(control.options).forEach(value => {
        value.disabled = !variants.some(candidate => candidate.dataset['option' + position] === value.value && candidate.dataset.inStock === 'true' && (control.dataset.ccStrictOption !== 'true' || [1,2,3].every(index => index === Number(position) || candidate.dataset['option' + index] === option.dataset['option' + index])));
      });
    });
    root.querySelectorAll('[data-cc-option-radio]').forEach(control => {
      const position = Number(control.dataset.ccOptionRadio);
      control.checked = control.value === option.dataset['option' + position];
      control.disabled = !variants.some(candidate => candidate.dataset.inStock === 'true' && [1,2,3].every(index => candidate.dataset['option' + index] === (index === position ? control.value : option.dataset['option' + index])));
    });
    root.querySelectorAll('[data-cc-option-name]').forEach(label => {
      label.textContent = option.dataset['option' + label.dataset.ccOptionName];
    });
    root.querySelectorAll('[data-cc-option-value]').forEach(chip => {
      const position = Number(chip.dataset.ccOptionPosition);
      const match = variants.find(candidate => root.classList.contains('cc-isc-layout') ? candidate.dataset['option' + position] === chip.dataset.ccOptionValue : [1,2,3].every(index => candidate.dataset['option' + index] === (index === position ? chip.dataset.ccOptionValue : option.dataset['option' + index])));
      chip.disabled = !match || match.dataset.inStock !== 'true';
      chip.setAttribute('aria-pressed', String(chip.dataset.ccOptionValue === option.dataset['option' + position]));
      chip.title = chip.dataset.ccOptionValue + (chip.disabled ? ' — ' + root.querySelector('[data-cc-unavailable-label]').textContent : '');
    });
    const iscPreview = root.querySelector('[data-cc-isc-preview] .cc-catalog-swatch');
    if (iscPreview && option.dataset.iscColor) iscPreview.style.setProperty('--cc-swatch', option.dataset.iscColor);
    const iscSds = root.querySelector('[data-cc-isc-sds]');
    if (iscSds) {
      const files = {"White":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5500-White.pdf","Ivory White":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5505-Ivory-White.pdf","Boulder":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5510-Boulder.pdf","Valley Brown":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5520-Valley-Brown.pdf","Caramel":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5540-Caramel.pdf","Glacier Gray":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5570-Glacier-Gray.pdf","Standard Gray":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5580-Standard-Gray.pdf","Grayhawk":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-6515-Grayhawk.pdf","Battleship":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5595-Battleship.pdf","Dusk":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5590-Dusk.pdf","Medium Gray":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5585-Medium-Gray.pdf","Root Beer":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5530-Root-Beer.pdf","Baked Clay":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5550-Baked-Clay.pdf","Safety Red":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5640-Safety-Red.pdf","Tile Red":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5560-Tile-Red.pdf","Construction Yellow":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-6616-Const-Yellow.pdf","Orange":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5635-Orange.pdf","Safety Yellow":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5630-Safety-Yellow.pdf","Green":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5620-Green.pdf","Moegi Green":"https://smithpaints.com/wp-content/uploads/2026/05/SDS-Smiths-ISC-5625-Moegi-Green.pdf","Black":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5600-Black.pdf","Smoked Blue":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-6610-Smoked-Blue.pdf","Blue":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5610-Blue.pdf","Regal Blue":"https://smithpaints.com/wp-content/uploads/2024/11/ISC-5615-Regal-Blue.pdf"};
      if (files[option.dataset.option1]) iscSds.href = files[option.dataset.option1];
    }
    const wscSds = root.querySelector('[data-cc-wsc-sds]');
    if (wscSds) {
      const files = {White:'WSC-5500-White-SDS.pdf', Boulder:'WSC-5510-Boulder-SDS.pdf', 'Glacier Gray':'WSC-5570-Glacier-Gray-SDS.pdf', Black:'WSC-5600-Black-SDS.pdf'};
      if (files[option.dataset.option1]) wscSds.href = 'https://smithpaints.com/wp-content/uploads/2024/11/' + files[option.dataset.option1];
    }
    root.querySelectorAll('[data-cc-tds-finish]').forEach(link => {
      const lowSheen = [1,2,3].some(index => /low sheen/i.test(option.dataset['option' + index] || ''));
      link.href = lowSheen ? link.dataset.ccTdsLow : link.dataset.ccTdsGloss;
    });
    root.querySelectorAll('[data-cc-tds-formula]').forEach(link => {
      link.href = /SLS125/.test(option.dataset.option1 || '') ? link.dataset.ccTdsWinter : link.dataset.ccTdsRegular;
    });
  }
  function chooseCatalogOption(root, position, value, strict) {
    const select = root.querySelector('[data-cc-variant]');
    const current = select.selectedOptions[0];
    const choices = Array.from(select.options).filter(candidate => candidate.dataset['option' + position] === value);
    const exact = choices.find(candidate => [1,2,3].every(index => index === position || candidate.dataset['option' + index] === current.dataset['option' + index]));
    const next = strict ? (exact?.dataset.inStock === 'true' ? exact : null) : (exact?.dataset.inStock === 'true' ? exact : choices.find(candidate => candidate.dataset.inStock === 'true') || exact || choices[0]);
    if (next) { select.value = next.value; syncCoatingsVariant(select); }
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cc-option-select]')) chooseCatalogOption(event.target.closest('[data-cc-product]'), Number(event.target.dataset.ccOptionSelect), event.target.value, event.target.dataset.ccStrictOption === 'true');
    if (event.target.matches('[data-cc-option-radio]')) chooseCatalogOption(event.target.closest('[data-cc-product]'), Number(event.target.dataset.ccOptionRadio), event.target.value, true);
  });
  document.addEventListener('click', event => {
    const chip = event.target.closest('[data-cc-option-value]');
    if (chip && !chip.disabled) chooseCatalogOption(chip.closest('[data-cc-product]'), Number(chip.dataset.ccOptionPosition), chip.dataset.ccOptionValue, !chip.closest('[data-cc-product]').classList.contains('cc-isc-layout'));
  });
  function syncIntegralColorControls(root, option) {
    const preview = root.querySelector('[data-cc-integral-preview]');
    if (!preview) return;
    const isPack = option.dataset.option1 === 'Pack';
    const packagePhoto = root.querySelector('[data-cc-integral-package]');
    const showPackage = isPack && option.dataset.option2 === 'Concrete Gray' && !!packagePhoto;
    if (packagePhoto) packagePhoto.hidden = !showPackage;
    preview.hidden = showPackage;
    root.querySelector('[data-cc-integral-preview-note]').hidden = showPackage;
    preview.style.setProperty('--cc-integral-color', option.dataset.integralColor);
    root.querySelectorAll('[data-cc-integral-name]').forEach(label => { label.textContent = option.dataset.option2; });
    const stock = root.querySelector('[data-cc-integral-stock]');
    stock.textContent = option.dataset.stockText;
    stock.hidden = !isPack;
    const quantity = root.querySelector('[name="quantity"]');
    if (isPack) quantity.max = String(Math.max(0, Number(option.dataset.stock)));
    else quantity.removeAttribute('max');
    const variants = Array.from(root.querySelector('[data-cc-variant]').options);
    root.querySelectorAll('[data-cc-integral-value]').forEach(chip => {
      const match = variants.find(candidate => candidate.dataset.option1 === 'Pack' && candidate.dataset.option2 === chip.dataset.ccIntegralValue);
      chip.disabled = !match || match.dataset.inStock !== 'true';
      chip.setAttribute('aria-pressed', String(isPack && chip.dataset.ccIntegralValue === option.dataset.option2));
      chip.title = chip.dataset.ccIntegralValue + (chip.disabled ? ' — ' + root.querySelector('[data-cc-unavailable-label]').textContent : '');
    });
  }
  document.addEventListener('click', event => {
    const chip = event.target.closest('[data-cc-integral-value]');
    if (!chip || chip.disabled) return;
    const select = chip.closest('[data-cc-product]').querySelector('[data-cc-variant]');
    const next = Array.from(select.options).find(candidate => candidate.dataset.option1 === 'Pack' && candidate.dataset.option2 === chip.dataset.ccIntegralValue && candidate.dataset.inStock === 'true');
    if (next) { select.value = next.value; syncCoatingsVariant(select); }
  });
  function initializeCatalog(scope) {
    scope.querySelectorAll('[data-cc-product]').forEach(root => {
      if (!root.querySelector('[data-cc-color-floor]')) syncCoatingsVariant(root.querySelector('[data-cc-variant]'), false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeCatalog(document));
  else initializeCatalog(document);
  document.addEventListener('shopify:section:load', event => initializeCatalog(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
